module.exports = "/_next/static/images/ef9f20747d8520a6d890a10f442729c7-careers@1x.jpg";